import { render, staticRenderFns } from "./injurySite.vue?vue&type=template&id=6944d796&scoped=true&"
import script from "./injurySite.vue?vue&type=script&lang=js&"
export * from "./injurySite.vue?vue&type=script&lang=js&"
import style0 from "./injurySite.vue?vue&type=style&index=0&id=6944d796&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6944d796",
  null
  
)

export default component.exports